import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { clearAuthenticatedQueries } from "./query-cache";
import { authSessionQueryKey } from "./query-keys";

export function useLogin() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: api.auth.login,
    onSuccess: () => queryClient.setQueryData(authSessionQueryKey, true),
  });
}

export function useLogout() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: api.auth.logout,
    onSuccess: () => clearAuthenticatedQueries(queryClient),
  });
}
